// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class GatewayApisPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicGatewayApis';
        this.Server = this.props.context.getState().server.publicGatewayApis;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];
        this.showDatePicker = false;

        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName',
            },

        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
